import styled from 'styled-components';

export const FixedBottomSection = () => {
  const handlePluvaIonInquiryButton = () => {
    window.location.href = 'tel:15335502';
  };

  return (
    <Container>
      <BlurredSection />
      <BottomButton
        id="ion-call-fixed"
        onClick={handlePluvaIonInquiryButton}
      >
        <BottomButtonText>{'플루바 아이온 문의하기 1533-5502'}</BottomButtonText>
      </BottomButton>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  max-width: 512px;
  height: 72px;

  margin: 0 auto;
  padding: 0 16px;

  position: fixed;
  bottom: 0px;
  z-index: 100;

  background-color: #000000;
`;

const BlurredSection = styled.div`
  width: 100%;
  height: 40px;

  position: absolute;
  left: 0px;
  top: -40px;

  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
`;

const BottomButton = styled.button`
  width: 100%;
  height: 48px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 12px;
  background: #3D7BF5;
`;

const BottomButtonText = styled.span`
  color: #ffffff;

  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
`;
